import * as React from 'react';

const MegaphoneCollectionsSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} fill="none" {...props}>
        <path
            d="M5.782 12.739l.714 6.777c.089.842.828 1.484 1.712 1.484h1.922l-.87-4.168.87-3.181M4.043 12.305a3.043 3.043 0 110-6.087M4.043 6.218c4.318 0 10.37-1.607 13.788-4.783M4.043 12.304c4.318 0 10.377 1.606 13.794 4.783"
            stroke="#fff"
        />
        <path
            d="M13.82 6.251c.128-.872.31-1.697.54-2.459m-.003 10.87c-.475-1.585-.748-3.444-.748-5.431l.748 5.431zM16.652 11.867c.968-.058 1.74-1.106 1.74-2.392 0-1.285-.772-2.334-1.74-2.391"
            stroke="#fff"
        />
        <path
            d="M18.609 17.522c1.32 0 2.39-3.699 2.39-8.261C21 4.699 19.93 1 18.61 1c-1.321 0-2.392 3.699-2.392 8.26 0 4.563 1.07 8.262 2.392 8.262z"
            stroke="#fff"
        />
    </svg>
);

MegaphoneCollectionsSvg.displayName = 'MegaphoneCollectionsSvg';
export default MegaphoneCollectionsSvg;
